import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function PageHero({ label, title, subtitle, breadcrumbs = [] }) {
  return (
    <section className="relative pt-16 pb-14 md:pt-24 md:pb-20 border-b border-border/60 overflow-hidden">
      <div className="absolute inset-0 grain opacity-40 pointer-events-none" />
      <div className="absolute -top-32 -left-24 w-[500px] h-[500px] rounded-full bg-gold/5 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -right-24 w-[500px] h-[500px] rounded-full bg-navy/40 blur-3xl pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-4 md:px-8">
        {breadcrumbs.length > 0 && (
          <nav className="flex items-center gap-2 text-xs text-foreground/60 mb-6 tracking-wider uppercase">
            <Link to="/" className="hover:text-gold">Home</Link>
            {breadcrumbs.map((b, i) => (
              <span key={`${b.label}-${i}`} className="flex items-center gap-2">
                <ChevronRight size={12} />
                {b.to ? <Link to={b.to} className="hover:text-gold">{b.label}</Link> : <span className="text-gold">{b.label}</span>}
              </span>
            ))}
          </nav>
        )}
        {label && (
          <motion.p initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.5 }} className="section-label mb-4">
            <span className="inline-block w-8 h-px bg-gold align-middle mr-3" />
            {label}
          </motion.p>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="serif-display text-5xl md:text-6xl lg:text-7xl text-foreground max-w-4xl"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="mt-6 text-base md:text-lg text-foreground/70 leading-relaxed max-w-2xl"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
